import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import Select from "react-select";
import axios from "axios";
import { toast } from "react-toastify";

const AssignDriverForm = ({ show, onHide, vehicleId, onSuccess }) => {
  const [allDrivers, setAllDrivers] = useState([]);
  const [selectedDrivers, setSelectedDrivers] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchDrivers = async () => {
    try {
      // Use the new endpoint to get only available (unassigned) drivers
      const res = await axios.get("/drivers/available"); 
      const list = res.data || [];
      const driverOptions = list.map((d) => ({
        value: d.id?.toString(),
        label: (d.firstName || '') + (d.lastName ? " " + d.lastName : "") + (d.phoneNumber ? ` (${d.phoneNumber})` : ""),
      }));
      setAllDrivers(driverOptions);
    } catch (error) {
      toast.error("Failed to load available drivers");
    }
  };

  useEffect(() => {
    if (show) {
      fetchDrivers();
      setSelectedDrivers([]); 
    }
  }, [show]);

  const handleSubmit = async () => {
    if (!vehicleId) {
      toast.error("Vehicle ID is missing");
      return;
    }
    if (selectedDrivers.length === 0) {
      toast.error("Please select at least one driver");
      return;
    }
    try {
      setLoading(true);

      const driverIdArray = selectedDrivers.map((sd) => sd.value);

      const body = {
        vehicleId,      
        driverId: driverIdArray
      };

      await axios.post(`/addDriverVehicle/${vehicleId}`, body);

      toast.success("Drivers assigned successfully!");
      setLoading(false);
      onSuccess && onSuccess();
      onHide();              
    } catch (error) {
      setLoading(false);
      toast.error(error.response?.data?.msg || "Error assigning drivers");
    }
  };

  return (
    <Modal style={{marginTop: "60px"}} show={show} onHide={onHide} backdrop={false} centered>
      <Modal.Header closeButton>
        <Modal.Title>Assign Drivers</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>Select one or more drivers to assign to this vehicle:</p>
        <Select
            isMulti
            options={allDrivers}
            value={selectedDrivers}
            onChange={(value) => setSelectedDrivers(value)}
            placeholder="Select drivers..."
            menuPortalTarget={document.body} 
            styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                menu: (base) => ({ ...base, zIndex: 9999 }),
            }}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleSubmit} disabled={loading}>
          {loading ? "Assigning..." : "Assign"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AssignDriverForm;
